module.exports = __webpack_public_path__ + "img/board-125.883c1fd8.png";